import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/components/home/home.service';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss'],
})
export class BalanceComponent implements OnInit {
  public loading: boolean = false;

  public amount: number = 0;
  public blockedAmount: number = 0;
  public readyAmount: number = 0;

  constructor(private homeService: HomeService) {}

  ngOnInit(): void {
    this.loading = true;

    this.homeService.getBalance().subscribe({
      next: (response) => {
        this.amount = response.amount;
        this.blockedAmount = response.blockedAmount;
        this.readyAmount = response.readyAmount;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
